import { 
    Box,
    Typography, 
    Button, 
    IconButton, 
    styled, 
    useTheme, 
    Alert, 
    AlertTitle,
    Grid,
    Paper,
    TextField,
    Card,
    Autocomplete
} from "@mui/material";
import { Close } from "@mui/icons-material";
import SearchIcon from '@mui/icons-material/Search';
import Item from '@mui/material/Grid';

import { Fragment, useEffect, useState, SyntheticEvent } from "react";

import { meetings, recentPeopleGroups } from "data/data";

import ActionItemsColumn from "components/ActionItemsColumn";
import MissedActionItemsColumn from "components/MissedActionItemsColumn";
import LandingPage from "../LandingPage";
import Clock from "components/Clock";
import UpcomingItemsComponent from "components/UpcomingItemsComponent";
import MoteSuggestionsComponent from "components/MoteSuggestionsComponent";
import RecentItemsComponent from "components/RecentItemsComponent";
import HomePageAutocomplete from "components/HomePageAutocomplete";
import SearchResultComponent from "components/SearchResultComponent";

import { useSelector } from "react-redux";

const HomePage = () => {
    const [value, setValue] = useState(null);

    const getTimeOfDay = () => {
        const time = new Date().getHours();
        if (time < 12) { return 'Good Morning'; }
        else if (time > 12 && time < 18) { return 'Good Afternoon'; }
        else return 'Good Evening';
    };

    const isAuth = Boolean(useSelector((state) => state.auth.token));
    const user = useSelector((state) => state.auth.user);

    const handleValueChange = (event, value) => {
        setValue(value);
    }

    return (
        <Fragment>
            {isAuth ? (
                // SETS BACKGROUND
                <Box // Card
                    // raised
                    sx={{ 
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: "linear-gradient(179.2deg, #3B57B8 -105.91%, #DCE1FF 63.24%)",
                        height: "1500px",
                        display: 'flex',
                        // borderRadius: "35px",
                        // m: "2rem",
                     }}
                        
                >
                    {/* MAIN CONTAINER */}
                    <Box
                        sx={{
                            paddingTop: "50px",
                            paddingLeft: "100px",
                            paddingRight: "100px",
                            width: "100%",
                        }}
                    >
                        {/* TITLE */}
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '100%',
                                marginBottom: '1rem',
                            }}
                        >
                            <Typography
                                variant="h2"
                                fontWeight="bold"
                                sx={{
                                    color: "white",
                                }}
                            >
                                {`${getTimeOfDay()}, ${user.firstName}!`}
                            </Typography>
                            <Clock />
                        </Box>

                        {/* SEARCH BAR */}
                        {/* <SearchBarComponent /> */}
                        <HomePageAutocomplete handleValueChange={handleValueChange} />
                        

                        {/* MAIN CONTENT */}
                        <Grid 
                            container 
                            spacing={2} 
                            sx={{
                                marginTop: '15px',
                                height: "calc(100vh - 64px - 4rem)"
                            }}
                        >
                            <Grid item xs={9}>
                                <Item>
                                    {/* SEARCH ITEMS */}
                                    <SearchResultComponent item={value} />

                                    {/* RECENT ITEMS */}
                                    <RecentItemsComponent />
                                    
                                    {/* UPCOMING ITEMS */}
                                    <UpcomingItemsComponent />
                                </Item>
                            </Grid>
                            <Grid item xs={3}>
                                <Item>
                                    {/* ACTION ITEMS */}
                                    <ActionItemsColumn />

                                    {/* MISSED ACTION ITEMS */}
                                    <MissedActionItemsColumn />
                                    
                                    {/* MOTE SUGGESTIONS */}
                                    <MoteSuggestionsComponent />

                                </Item>
                            </Grid>
                        </Grid>
                    </Box>
                </Box> // Card              
            ) : (
                <LandingPage />
            )}
        </Fragment>
    );
};

export default HomePage;